<template>
  <div class="contact">
    <div class="top">
      <HightLight
        bg-text="Contact Us"
        :is-bg="true"
        text="联系我们"
        class="title"
      ></HightLight>
      <div class="left" :class="{ 'flex-column': screenWidth <= 768 }">
        <div>
          <img src="@/assets/png/intro.png" alt="" />
        </div>
        <div class="mes">
          <div>
            <p>
              <i class="el-icon-house"></i>
              <span style="margin-left:5px">宁波芯研瑞诺科技有限公司</span>
            </p>
          </div>
          <div>
            <p><i class="el-icon-mobile"></i>
              <span style="margin-left:5px">0574-83083863</span></p>
          </div>
          <div>
            <p><i class="el-icon-tickets"></i>
              <span style="margin-left:5px">nbxyrn@163.com</span></p>
          </div>
          <!-- <div>
            <p><i class="el-icon-phone-outline"></i>13705737315</p>
          </div> -->
          <div>
            <p>
              <i class="el-icon-location-information"></i
              >
              <span style="margin-left:5px">宁波市鄞州区下应北路789号6号楼3层301室</span>
            </p>
          </div>
        </div>
      </div>
      <div id="map" :style="{ width: mapWidth, height: mapHeight }"></div>
    </div>
  </div>
</template>

<script>
import HightLight from "@/components/common/hightLight/HightLight";
export default {
  name: "Contact",
  components: {
    HightLight,
  },
  data() {
    return {
      screenWidth: window.innerWidth,
      mapWidth: "100%",
      mapHeight: "389px",
    };
  },
  mounted() {
    this.initMap();
    window.addEventListener("resize", this.updateScreenWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateScreenWidth);
  },
  methods: {
    initMap() {
      let map = new BMap.Map("map");
      let point = new BMap.Point(121.599664, 29.819795);
      map.centerAndZoom(point, 15);
      map.addControl(new BMap.NavigationControl()); //添加控件
      map.addControl(new BMap.ScaleControl());
      map.addControl(new BMap.OverviewMapControl());
      map.addControl(new BMap.MapTypeControl());
      map.enableScrollWheelZoom(true); //开启滚动
      var marker = new BMap.Marker(point); // 创建标注
      map.addOverlay(marker);
    },
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
      this.setMapSize();
    },
    setMapSize() {
      if (this.screenWidth <= 768) {
        this.mapWidth = "100%";
        this.mapHeight = "300px";
      } else {
        this.mapWidth = "1200px";
        this.mapHeight = "389px";
      }
    },
  },
};
</script>

<style scoped>
.contact {
  display: flex;
  justify-content: center;
}

.top {
  width: 100%;
  max-width: 1200px;
}

.left {
  display: flex;
  height: auto;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #cccccc;
  padding-left: 65px;
  margin-bottom: 50px;
}

.left img {
  height: 200px;
  /* width: 200px; */
  border-right: 1px solid #cccccc;
}

.mes {
  margin-left: 10px;
  font-size: 18px;
  color: #666666;
}

#map {
  margin-bottom: 25px;
}

.title {
  margin-right: 13px;
}

.tag {
  text-align: center;
  margin-bottom: 25px;
  font-size: 28px;
  font-weight: bolder;
  color: red;
}

@media screen and (max-width: 768px) {
  .left.flex-column {
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding-left: 0;
  }
}

</style>
